
const utils = {
    getPaymentType: function (paymentType,vm) {
        if(paymentType==='') {
            return "";
        }
        return vm.$t('receipt.'+paymentType.toLowerCase()+'Payment');
    }
}

export default utils;